module.exports = __webpack_public_path__ + "static/scale-model-of-border-heritage-museum-in-laredo-texas-28e0e8966baf4e7fd9bc3d48ed5b988c.png";